<template>
  <FormulateForm
    @submit="forgotPasswort"
    class="accent-form"
    :form-errors="error"
  >
    <FormulateInput
      type="text"
      class="span-full"
      name="email"
      label="E-Mail Adresse"
      v-model="email"
      error-behavior="submit"
      validation="required|email"
    />
    <FormulateInput
      type="submit"
      class="span-full"
      :value="saving"
      label="Absenden"
    />
  </FormulateForm>
</template>

<script>
import AuthService from "@/services/authentication";

export default {
  name: "ForgotPasswordForm",
  data() {
    return {
      error: [],
      saving: false,
      email: null,
    };
  },
  methods: {
    async forgotPasswort() {
      this.saving = true;
      try {
        this.error = [];
        await AuthService.forgotPassword(this.email);
        this.$listeners.submit();
        this.email = null;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.error = ["E-Mail Adresse nicht gefunden!"];
        } else {
          this.error = ["Passwort zurücksetzen fehlgeschlagen!"];
        }
        console.error(e);
      }
      this.saving = false;
    },
  },
};
</script>
